import ZeroBudget2026 from "./Components/Blogs/ZeroBudget2026";

// seoConfig.js
const seoConfig = {
  home: {
    title: "Best Budget - Where financial freedom begins.",
    description:
      "Take control of your money with Best Budget  the personal finance app for budgeting, expense tracking & saving. Start your free budget plan today!.",
    primaryKeywords: [
      "Best Budget: Money Manager"
    ],
    secondaryKeywords: [
      'personal finance app', 'expense tracker app', 'budget app'
    ],

  },

  whyBestBudget: {
    title: "Why Best Budget? Easy Money Management app for Beginners.",
    description:
      "Discover how Best Budget makes money management easy. Envelope budgeting, expense tracking & debt payoff tools  built for beginners. Start your free trial !",
    primaryKeywords: [
      'money management made easy'
    ],
    secondaryKeywords: [
      'budgeting for beginners', 'personal finance app for beginners', 'daily expense tracker'
    ],
  },



  pricing: {
    title: "Best Budget Pricing – Free Trial & Premium Plans",
    description:
      "Start budgeting for free or unlock premium money management features. Compare Best Budget plans & find the best budgeting app for beginners free. Upgrade anytime!",
    primaryKeywords: [
      'best budgeting app for beginners free'
    ],
    secondaryKeywords: [
      'budget app', 'best app to track spending', 'zero based budget apps'
    ],

  },
  learn: {
    title: "Learn how to get the most out of Best Budget to progress fast towards your financial goals",
    description:
      "New to budgeting? Explore Best Budget's guides & videos on money management, expense tracking & financial planning. Start your journey to smarter saving today!",
    primaryKeywords: [
      'financial planning'
    ],
    secondaryKeywords: [
      'save money each month', 'budgeting for beginners', 'budget planner for saving money'
    ],

  },
  blog: {
    title: "Best Budget Blog – Money Management & Budgeting Tips",
    description:
      "Explore expert tips on budgeting, money management, expense tracking & financial planning. Read Best Budget's blog & start making smarter money decisions today!",
    primaryKeywords: [
      'money management'
    ],
    secondaryKeywords: [
      'spending tracker app', 'monthly budget planner', 'best budget planner'
    ],

  },

  about: {
    title: "Know about people behind Best Budget.",
    description:
      "Meet the team behind Best Budget, the best money management app designed to help you save money each month. Learn our story & mission. Start budgeting smarter today!",
    primaryKeywords: [
      'best money management app'
    ],
    secondaryKeywords: [
      'save money each month', 'personal finance app', 'money management'
    ],


  },
  privacyPolicy: {
    title: "Privacy Policy | Best Budget Finance Tracker App.",
    description:
      "Read how Best Budget protects your personal data.Our privacy policy explains how your information is used in our secure budget app. Your privacy matters to us.",
    primaryKeywords: [
      'finance tracker app'
    ],
    secondaryKeywords: [
      'budget app', 'Best Budget: Money Manager'
    ],

  },
  serviceTerms: {
    title: "Terms of Service | Best Budget App for Saving Money",
    description:
      "Review the terms of service for Best Budget, your trusted budget app for saving money. Understand your rights and our commitments before using our platform.",
    primaryKeywords: [
      'budget app for saving money'
    ],
    secondaryKeywords: [
      'budget planner for saving money', 'Best Budget: Money Manager'
    ],

  },
  security: {
    title: "Security | Best Budget Secure Personal Finance App",
    description:
      "Your financial data is safe with Best Budget. Explore our security measures for your personal finance app encrypted, private & built for your peace of mind.",
    primaryKeywords: [
      'personal finance app'
    ],
    secondaryKeywords: [
      'Best Budget: Money Manager', 'finance tracker app'
    ],

  },
  cookies: {
    title: "Cookies Policy | Best Budget Money Manager App",
    description:
      "Learn how Best Budget uses cookies to improve your experience on our money manager app. Manage your cookie preferences easily. Read our full cookies policy now.",
    primaryKeywords: [
      'Best Budget: Money Manager'
    ],
    secondaryKeywords: [
      'budget app', 'money management planner', 'finance tracker app'
    ],

  },
  learningCenter: {
    title: "Learning Center | Best Budget Money Management App",
    description:
      "Access the Best Budget Learning Center for step-by-step guides on budgeting, expense tracking & personal finance. Master money management at your own pace. Start now!",
    primaryKeywords: [
      'money management app'
    ],
    secondaryKeywords: [
      'budgeting for beginners', 'personal finance app', 'best budget planner'
    ],

  },
  financialPlanning: {
    title: "Financial Planning Tips to Achieve Better Money Outcomes",
    description: 'Learn proven financial planning strategies to grow your savings & reach your goals. Discover how Best Budget makes personal finance easy. Read the full guide now!',
    primaryKeywords: [
      'financial planning'
    ],
    secondaryKeywords: [
      'personal finance app', 'save money each month', 'best budget planner'
    ],
  },
  budgetingBlog: {
    title: "How Budgeting Drives Financial Success | Best Budget Blog",
    description: 'Discover how smart budgeting leads to financial success. Learn easy money management tips & start your journey with Best Budget today. Read the full blog post now!',
    primaryKeywords: [
      'money management made easy'
    ],
    secondaryKeywords: [
      'budget app', 'budgeting for beginners', 'monthly budget planner'
    ],
  },
  investingBlog: {
    title: "Top Tips for Tracking All Your Investments in One Place",
    description: "Stay on top of your investments with Best Budget's easy Expense tracker. Get expert tips to track spending & investments in one place. Read the full guide today!",
    primaryKeywords: [
      'finance tracker app'
    ],
    secondaryKeywords: [
      'best app to track spending', 'personal finance app', 'money management'
    ],
  },
  savingMoneyBlog: {
    title: "Effective Tips to Save Money Quickly & Easily | Best Budget",
    description: "Start saving money each month with these simple, proven tips. Use Best Budget to build your savings plan & reach your goals faster. Read the full article now!",
    primaryKeywords: [
      'save money each month'
    ],
    secondaryKeywords: [
      'budget planner for saving money', 'best budgeting app for beginners free', 'spending tracker app'
    ],
  },
  smartSpendingBlog: {
    title: "Smart Personal Finance Management in 2025 | Best Budget",
    description: 'Take charge of your money in 2025 with smart personal finance strategies. Learn budgeting, saving & expense tracking tips with Best Budget. Read the guide now!',
    primaryKeywords: [
      'personal finance app'
    ],
    secondaryKeywords: [
      'money management, financial planning, best money management app'
    ],
  },
  ZeroBudget2026: {
    title: "Zero Based Budgeting: The Complete 2026 Guide | Best Budget",
    description: "Master zero-based budgeting in 2026 with Best Budget. Learn how to allocate every dollar effectively & achieve your financial goals. Read the full guide now!",
    primaryKeywords: [
      'zero based budgeting'
    ],
    secondaryKeywords: [
      'zero based budget apps', 'best budgeting app for beginners free', 'budgeting for beginners'
    ],
  },
  quickAccess: {
    title: "Quick Sign Up & Login Guide | Best Budget App Tutorial",
    description: "Watch this quick video to sign up and log in to Best Budget in minutes. Get started with the best personal finance app for beginners today. Begin budgeting now!",
    primaryKeywords: [
      'personal finance app for beginners'
    ],
    secondaryKeywords: [
      'best budgeting app for beginners free', 'budget app', 'money management app'
    ],
  },
  settingUpBestBudget: {
    title: "First Steps: Set Up Best Budget Like a Pro | Tutorial",
    description: "New to Best Budget? Watch this beginner setup video and start managing your money like a pro. Learn budgeting basics & set up your budget plan in just minutes!",
    primaryKeywords: [
      'budgeting for beginners'
    ],
    secondaryKeywords: [
      'personal finance app for beginners', 'money management made easy', 'budget app'
    ],

  },
   addingAccounts: {
    title: "Organize Finances by Adding & Managing Accounts | Best Budgetl",
    description: 'Learn how to add and manage accounts in Best Budget to keep your finances organized. Watch the step-by-step video guide and start tracking your money today!',
    primaryKeywords: [
      'money management made easy'
    ],
    secondaryKeywords: [
      'finance tracker app', 'personal finance app', 'daily expense tracker'
    ],
  },
    managingBudgetCategories: {
    title: "Organize Finances by Adding & Managing Accounts | Best Budgetl",
    description: 'Learn how to add and manage accounts in Best Budget to keep your finances organized. Watch the step-by-step video guide and start tracking your money today!',
    primaryKeywords: [
      'money management made easy'
    ],
    secondaryKeywords: [
      'finance tracker app', 'personal finance app', 'daily expense tracker'
    ],
  },
  trackPayeeTransaction:{
    title: "Track & Manage Payees and Transactions | Best Budget",
    description: 'Easily track and manage your payments, payees & transactions with Best Budget. Watch our simple video guide to master daily expense tracking. Get started free!',
    primaryKeywords: [
      'daily expense tracker'
    ],
    secondaryKeywords: [
     'expense tracker app', 'best expense tracker app', 'spending tracker app'
    ],
  },
    dashboardReport:{
    title: "Financial Dashboard & Reports Explained | Best Budget",
    description: "Understand your financial overview with Best Budget's dashboard & reports. Watch the video guide to get insights on your spending, savings & budget performance.",
    primaryKeywords: [
      'best app to track spending'
    ],
    secondaryKeywords: [
   'finance tracker app', 'money management app', 'personal finance app'
    ],
  },
      personalizeSetting:{
    title: "Manage Budgets & Personalize Settings | Best Budget App",
    description: "Learn how to manage your budgets and personalize app settings in Best Budget. Watch the tutorial and take full control of your personal finance experience today!",
    primaryKeywords: [
      'best money management app'
    ],
    secondaryKeywords: [
   'budget app', 'money management made easy', 'personal finance app'
    ],
  },
    startBudgeting:{
    title: "How to Start Budgeting | Best Budget Beginner Guide",
    description: "Ready to start budgeting? Follow Best Budget's beginner-friendly guide to set up your first budget plan. Track spending & save money each month. Begin today free!",
    primaryKeywords: [
      'budgeting for beginners'
    ],
    secondaryKeywords: [
   'save money each month', 'budget app', 'best budgeting app for beginners free'
    ],
  },
      InviteMember:{
    title: "How to Invite a Member | Best Budget Shared Budgeting",
    description: "Learn how to invite a member to your Best Budget plan. Share your budget with a partner or family and manage finances together. Explore our budget app for couples!",
    primaryKeywords: [
      'budget app for couples'
    ],
    secondaryKeywords: [
  'share budget',' money management app', 'personal finance app'
    ],
  },
     ManageInvitation:{
    title: "Manage Budget Invitations | Best Budget App Guide",
    description: "Learn how to manage invitations in Best Budget and control who joins your shared budget plan. Perfect for couples and families managing money together. Start now!",
    primaryKeywords: [
      'budget app for couples'
    ],
    secondaryKeywords: [
'money management app', 'share budget', 'best money management app'
    ],
  },
       RemoveInvitation:{
    title: "How to Remove a Member | Best Budget Group Budgeting",
    description: "Step-by-step guide to removing a member from your Best Budget group plan. Manage your shared budget with full control and flexibility. Learn how it works now!",
    primaryKeywords: [
      'budget app for couples'
    ],
    secondaryKeywords: [
'money management app', 'best money management app', 'share budget'
    ],
  },
leaveGroup: {
  title: "How to Leave a Budget Group | Best Budget Help Guide",
  description:
    "Learn how to leave a shared budget group in Best Budget. Follow our simple step-by-step guide and manage your personal finance settings with ease. Read now!",
  primaryKeywords: ["money management app"],
  secondaryKeywords: [
    "budget app",
    "personal finance app",
    "best money management app",
  ],
},

createBudgetPlan: {
  title: "How to Create Budget Plans | Best Budget App Guide",
  description:
    "Create your first budget plan with Best Budget in minutes. Follow our easy guide for beginners and start managing your money smarter. Try the free budget app today!",
  primaryKeywords: ["budget planner for saving money"],
  secondaryKeywords: [
    "budgeting for beginners",
    "zero based budget",
    "monthly budget planner",
  ],
},

editBudgetPlan: {
  title: "How to Edit Your Budget Plan | Best Budget App Help",
  description:
    "Learn how to edit and update your budget plan in Best Budget. Keep your finances flexible and on track with our easy money management tools. Read the guide now!",
  primaryKeywords: ["money management made easy"],
  secondaryKeywords: [
    "budget app",
    "monthly budget planner",
    "best budget planner",
  ],
},

shareBudget: {
  title: "How to Share Your Budget | Best Budget for Couples",
  description:
    "Learn how to share your budget plan with a partner or family member in Best Budget. Manage money together with our easy budget app for couples. Start today free!",
  primaryKeywords: ["budget app for couples"],
  secondaryKeywords: [
    "share budget",
    "money management app",
    "best money management app",
  ],
},

switchBudgetPlan: {
  title: "How to Switch Budget Plans | Best Budget Help Center",
  description:
    "Easily switch between budget plans in Best Budget. Learn how to manage multiple budgets and keep your personal finances organized. Follow our step-by-step guide!",
  primaryKeywords: ["money management app"],
  secondaryKeywords: [
    "budget app",
    "best budget planner",
    "monthly budget planner",
  ],
},

transferOwnership: {
  title: "How to Transfer Budget Ownership | Best Budget Guide",
  description:
    "Learn how to transfer ownership of a budget plan in Best Budget. Manage group budgets with ease and keep your shared finances in order. Read the full guide now!",
  primaryKeywords: ["best money management app"],
  secondaryKeywords: [
    "budget app for couples",
    "money management app",
    "share budget",
  ],
},

deleteBudgetPlan: {
  title: "How to Delete a Budget Plan | Best Budget Help Guide",
  description:
    "Follow our simple guide to delete a budget plan in Best Budget. Manage your personal finance settings with full control and flexibility. Learn how it works now!",
  primaryKeywords: ["budget app"],
  secondaryKeywords: [
    "money management app",
    "personal finance app",
    "best budget planner",
  ],
},

addAccountGuide: {
  title: "How to Add an Account | Best Budget Finance Tracker",
  description:
    "Learn how to add a new account in Best Budget and start tracking your money in one place. Set up your finance tracker app quickly with our easy step-by-step guide!",
  primaryKeywords: ["finance tracker app"],
  secondaryKeywords: [
    "best app to track spending",
    "money management app",
    "expense tracker app",
  ],
},

editAccountGuide: {
  title: "How to Edit an Account | Best Budget App Help Center",
  description:
    "Easily update your account details in Best Budget. Follow our simple guide to edit account information and keep your personal finances accurate and up to date!",
  primaryKeywords: ["money management app"],
  secondaryKeywords: [
    "finance tracker app",
    "budget app",
    "personal finance app",
  ],
},

closeAccountGuide: {
  title: "How to Close an Account | Best Budget Help Guide",
  description:
    "Learn how to close an account in Best Budget step by step. Manage your personal finance app settings with confidence and keep your budget plan accurate and clean.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "finance tracker app",
  ],
},

reopenAccountGuide: {
  title: "How to Reopen an Account | Best Budget Help Center",
  description:
    "Easily reopen a closed account in Best Budget with our step-by-step guide. Restore your finance tracking and keep your budget plan up to date. Read how now!",
  primaryKeywords: ["finance tracker app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "personal finance app",
  ],
},

changeBalanceGuide: {
  title: "How to Change Account Balance | Best Budget Guide",
  description:
    "Learn how to manually change your account balance in Best Budget. Keep your expense tracker accurate and your personal finances always up to date. Read now!",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "best expense tracker app",
    "finance tracker app",
    "money management app",
  ],
},

reconcileAccountGuide: {
  title: "How to Reconcile an Account | Best Budget Finance App",
  description:
    "Learn how to reconcile your accounts in Best Budget to ensure your records match your bank. Keep your finances accurate & your budget on track. Read the guide!",
  primaryKeywords: ["best app to track spending"],
  secondaryKeywords: [
    "finance tracker app",
    "expense tracker app",
    "money management app",
  ],
},

rearrangeAccountGuide: {
  title: "How to Rearrange Accounts | Best Budget App Help",
  description:
    "Easily rearrange and organize your accounts in Best Budget. Follow our quick guide to customize your finance tracker layout and manage your money more efficiently.",
  primaryKeywords: ["money management made easy"],
  secondaryKeywords: [
    "finance tracker app",
    "money management app",
    "budget app",
  ],
},
createBankConnection: {
  title: "How to Create a New Bank Connection | Best Budget App",
  description:
    "Connect your bank to Best Budget and automate expense tracking instantly. Follow our easy guide to create a new bank connection. Start tracking your money now!",
  primaryKeywords: ["best app to track spending"],
  secondaryKeywords: [
    "finance tracker app",
    "expense tracker app",
    "money management app",
  ],
},

editBankConnection: {
  title: "How to Edit a Bank Connection | Best Budget Help Guide",
  description:
    "Update your bank connection settings in Best Budget easily. Follow our step-by-step guide to edit your linked bank and keep your expense tracker running smoothly.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "best expense tracker app",
    "finance tracker app",
    "money management app",
  ],
},

manageBankConnections: {
  title: "Manage Bank Connections | Best Budget Finance Tracker",
  description:
    "Learn how to manage all your bank connections in Best Budget. Keep your linked accounts organized and your daily expense tracker accurate. Follow our guide now!",
  primaryKeywords: ["daily expense tracker"],
  secondaryKeywords: [
    "finance tracker app",
    "best app to track spending",
    "money management app",
  ],
},

closeLinkedAccount: {
  title: "How to Close a Linked Bank Account | Best Budget Help",
  description:
    "Learn how to safely close a linked bank account in Best Budget. Follow our simple guide to manage your bank connections and keep your finances clean and accurate.",
  primaryKeywords: ["finance tracker app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "expense tracker app",
  ],
},

reauthenticateBankConnection: {
  title: "Reauthenticate Bank Connection | Best Budget App Help",
  description:
    "Fix your bank connection in Best Budget with our easy reauthentication guide. Keep your expense tracker synced and your personal finances always up to date!",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "finance tracker app",
    "best app to track spending",
    "money management app",
  ],
},

transactionsToReview: {
  title: "How to Review Transactions | Best Budget Expense Tracker",
  description:
    "Learn how to review and approve transactions in Best Budget. Stay on top of your daily expenses and keep your personal finance tracker accurate. Read the guide!",
  primaryKeywords: ["daily expense tracker"],
  secondaryKeywords: [
    "expense tracker app",
    "best expense tracker app",
    "finance tracker app",
  ],
},

budgetPlanGuide: {
  title: "How to Use a Budget Plan | Best Budget App Guide",
  description:
    "Learn how to create and use a budget plan in Best Budget to manage your money wisely. Perfect for beginners. Start your free budget planner for saving money today!",
  primaryKeywords: ["budget planner for saving money"],
  secondaryKeywords: [
    "budgeting for beginners",
    "zero based budget",
    "monthly budget planner",
  ],
},

addCategoryGroup: {
  title: "How to Add a Category Group | Best Budget Help Guide",
  description:
    "Learn how to add a category group in Best Budget to organize your spending. Set up your monthly budget planner and track expenses by category with ease. Start now!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "zero based budget apps",
    "best budget planner",
  ],
},

addCategory: {
  title: "How to Add a Budget Category | Best Budget App Help",
  description:
    "Add spending categories to your Best Budget plan and track every dollar easily. Follow our beginner-friendly guide to build your perfect monthly budget planner!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "zero based budget",
    "best budget planner",
  ],
},

editCategoryGroup: {
  title: "How to Edit a Category Group | Best Budget Help Center",
  description:
    "Easily edit and update category groups in Best Budget. Keep your monthly budget planner organized and your spending categories accurate. Follow our guide now!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "money management made easy",
    "best budget planner",
  ],
},

editCategory: {
  title: "How to Edit a Budget Category | Best Budget App Help",
  description:
    "Update your budget categories in Best Budget quickly and easily. Keep your spending tracker organized and your personal budget plan always accurate. Read how now!",
  primaryKeywords: ["spending tracker app"],
  secondaryKeywords: [
    "monthly budget planner",
    "budget app",
    "money management made easy",
  ],
},

hideCategoryGroup: {
  title: "How to Hide a Category Group | Best Budget App Guide",
  description:
    "Learn how to hide a category group in Best Budget to keep your budget clean and focused. Customize your monthly budget planner with ease. Follow our guide now!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "money management app",
    "best budget planner",
  ],
},

hideCategory: {
  title: "How to Hide a Budget Category | Best Budget Help Guide",
  description:
    "Easily hide unused budget categories in Best Budget to simplify your view. Keep your personal finance app clean and focused on what matters most. Read now!",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "budget app",
    "monthly budget planner",
    "money management app",
  ],
},

moveCategory: {
  title: "How to Move a Budget Category | Best Budget Help",
  description:
    "Learn how to move a budget category to a different group in Best Budget. Keep your monthly budget planner organized and easy to manage. Follow our simple guide!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "money management made easy",
    "best budget planner",
  ],
},
rearrangeCategories: {
  title: "How to Rearrange Budget Categories | Best Budget App",
  description:
    "Organize your budget categories in Best Budget by rearranging them to fit your lifestyle. Customize your monthly budget planner for smarter money management today!",
  primaryKeywords: ["money management made easy"],
  secondaryKeywords: [
    "monthly budget planner",
    "budget app",
    "best budget planner",
  ],
},

individualAllocation: {
  title: "How to Set Individual Budget Allocation | Best Budget",
  description:
    "Learn how to allocate money to individual budget categories in Best Budget. Take control of your spending with zero based budgeting & smart money management.",
  primaryKeywords: ["zero based budget"],
  secondaryKeywords: [
    "zero based budget apps",
    "monthly budget planner",
    "best budget planner",
  ],
},

transferAllocation: {
  title: "How to Transfer Budget Allocation | Best Budget Guide",
  description:
    "Move budget allocations between categories in Best Budget with ease. Keep your zero based budget balanced and your money management on track. Read the guide now!",
  primaryKeywords: ["zero based budget"],
  secondaryKeywords: [
    "zero based budget apps",
    "money management made easy",
    "monthly budget planner",
  ],
},

allocateBasedOnPastStatistics: {
  title: "Allocate Budget Using Past Stats | Best Budget App",
  description:
    "Use past spending statistics to allocate your budget smarter in Best Budget. Let data guide your monthly budget planner and save money each month effortlessly!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "save money each month",
    "zero based budget",
    "best app to track spending",
  ],
},

collectiveAllocation: {
  title: "How to Use Collective Budget Allocation | Best Budget",
  description:
    "Learn how to allocate budget collectively across categories in Best Budget. Simplify your zero based budgeting and manage your money smarter every month. Read now!",
  primaryKeywords: ["zero based budget apps"],
  secondaryKeywords: [
    "zero based budget",
    "monthly budget planner",
    "money management made easy",
  ],
},

deleteCategoryGroup: {
  title: "How to Delete a Category Group | Best Budget Help",
  description:
    "Learn how to delete a category group in Best Budget to keep your budget plan clean. Manage your monthly budget planner with full control. Follow our guide now!",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "money management app",
    "best budget planner",
  ],
},

deleteCategory: {
  title: "How to Delete a Budget Category | Best Budget App Help",
  description:
    "Remove unwanted budget categories in Best Budget easily. Keep your personal finance app organized and your monthly budget planner simple. Follow our guide now!",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "monthly budget planner",
    "budget app",
    "money management app",
  ],
},

addIncome: {
  title: "How to Add Income in Best Budget | Finance Tracker Guide",
  description:
    "Learn how to add income transactions in Best Budget to keep your finance tracker accurate. Track every dollar you earn and manage your money smarter. Start now!",
  primaryKeywords: ["finance tracker app"],
  secondaryKeywords: [
    "best app to track spending",
    "money management app",
    "daily expense tracker",
  ],
},

addExpense: {
  title: "How to Add an Expense | Best Budget Expense Tracker",
  description:
    "Learn how to record expense transactions in Best Budget. Stay on top of your spending, track expenses accurately and improve your money management habits today.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "daily expense tracker",
    "best expense tracker app",
    "money management app",
  ],
},

makeTransfer: {
  title: "How to Make a Transfer | Best Budget Finance Guide",
  description:
    "Transfer money between accounts in Best Budget with ease. Follow our simple guide to keep your finance tracker accurate and your budget always up to date.",
  primaryKeywords: ["finance tracker app"],
  secondaryKeywords: [
    "money management app",
    "expense tracker app",
    "personal finance app",
  ],
},

addRecurringTransaction: {
  title: "How to Add a Recurring Transaction | Best Budget",
  description:
    "Automate your finances by adding recurring transactions in Best Budget. Save time, stay organized and keep your expense tracker accurate every month.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "daily expense tracker",
    "money management app",
    "personal finance app",
  ],
},

filterTransactions: {
  title: "How to Filter Transactions | Best Budget Guide",
  description:
    "Learn how to filter transactions in Best Budget and quickly find the spending data you need. Manage your finances smarter with powerful search tools.",
  primaryKeywords: ["daily expense tracker"],
  secondaryKeywords: [
    "expense tracker app",
    "finance tracker app",
    "best app to track spending",
  ],
},

searchTransactions: {
  title: "How to Search Transactions | Best Budget Help",
  description:
    "Find transactions instantly in Best Budget using powerful search tools. Stay organized and manage your personal finances with confidence.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "daily expense tracker",
    "finance tracker app",
    "money management app",
  ],
},

deleteTransactions: {
  title: "How to Delete Transactions | Best Budget Guide",
  description:
    "Learn how to delete transactions in Best Budget and keep your records clean and accurate. Follow our simple step-by-step guide today.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "daily expense tracker",
    "finance tracker app",
    "money management app",
  ],
},

duplicateTransactions: {
  title: "How to Duplicate Transactions | Best Budget App",
  description:
    "Save time by duplicating transactions in Best Budget. Quickly recreate recurring spending entries and keep your expense tracking efficient.",
  primaryKeywords: ["daily expense tracker"],
  secondaryKeywords: [
    "expense tracker app",
    "finance tracker app",
    "money management app",
  ],
},

editTransactions: {
  title: "How to Edit Transactions | Best Budget Help Guide",
  description:
    "Update and edit transactions in Best Budget with ease. Keep your expense tracker accurate and your personal finance records always up to date.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "finance tracker app",
    "daily expense tracker",
    "money management app",
  ],
},
dashboardSummary: {
  title: "Dashboard Summary | Best Budget Finance Overview",
  description:
    "Get a complete overview of your finances with the Dashboard Summary in Best Budget. Track income, expenses and budget performance in one place.",
  primaryKeywords: ["money management app"],
  secondaryKeywords: [
    "finance tracker app",
    "personal finance app",
    "best app to track spending",
  ],
},

dashboardAllocations: {
  title: "Budget Allocations Dashboard | Best Budget Guide",
  description:
    "Monitor your budget allocations in Best Budget and stay on track with your spending goals. View category allocations and manage your money smarter.",
  primaryKeywords: ["monthly budget planner"],
  secondaryKeywords: [
    "budget app",
    "zero based budget",
    "money management app",
  ],
},

dashboardTopSpenders: {
  title: "Top Spenders Dashboard | Best Budget Analytics",
  description:
    "Identify your biggest spending categories with the Top Spenders Dashboard in Best Budget. Gain valuable insights and improve your budgeting decisions.",
  primaryKeywords: ["best app to track spending"],
  secondaryKeywords: [
    "expense tracker app",
    "money management app",
    "finance tracker app",
  ],
},

dashboardUpcoming: {
  title: "Upcoming Transactions Dashboard | Best Budget",
  description:
    "Stay prepared with upcoming transactions in Best Budget. View future income and expenses to plan your budget and avoid surprises.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "expense tracker app",
    "money management app",
    "budget planner for saving money",
  ],
},

spendingAnalysis: {
  title: "Spending Analysis Report | Best Budget Insights",
  description:
    "Analyze your spending habits with Best Budget's Spending Analysis Report. Discover trends, track expenses and make smarter financial decisions.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "best expense tracker app",
    "money management app",
    "finance tracker app",
  ],
},

networthReport: {
  title: "Net Worth Report | Best Budget Personal Finance",
  description:
    "Track your financial progress with the Net Worth Report in Best Budget. Monitor assets, liabilities and overall financial health over time.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "finance tracker app",
    "financial planning",
  ],
},

addPayee: {
  title: "How to Add a Payee | Best Budget Guide",
  description:
    "Learn how to add payees in Best Budget and organize your transactions efficiently. Simplify expense tracking and improve financial management.",
  primaryKeywords: ["expense tracker app"],
  secondaryKeywords: [
    "daily expense tracker",
    "money management app",
    "finance tracker app",
  ],
},

editPayee: {
  title: "How to Edit a Payee | Best Budget Help Center",
  description:
    "Update payee information in Best Budget quickly and easily. Keep your transaction records accurate and organized with our simple guide.",
  primaryKeywords: ["money management app"],
  secondaryKeywords: [
    "expense tracker app",
    "finance tracker app",
    "personal finance app",
  ],
},

searchPayee: {
  title: "How to Search Payees | Best Budget Guide",
  description:
    "Find payees instantly in Best Budget using powerful search tools. Stay organized and manage your transaction history with ease.",
  primaryKeywords: ["daily expense tracker"],
  secondaryKeywords: [
    "expense tracker app",
    "money management app",
    "finance tracker app",
  ],
},

editProfile: {
  title: "How to Edit Profile Details | Best Budget Account Guide",
  description:
    "Learn how to update your profile information in Best Budget. Keep your account details accurate and personalize your finance management experience.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "finance tracker app",
  ],
},

changeEmail: {
  title: "How to Change Your Email | Best Budget Help Guide",
  description:
    "Update your email address in Best Budget quickly and securely. Follow our simple guide to keep your account information up to date.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "finance tracker app",
  ],
},

deleteAccountGuide: {
  title: "How to Delete Your Account | Best Budget Help Center",
  description:
    "Learn how to permanently delete your Best Budget account. Follow our step-by-step guide to manage your personal finance settings with confidence.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "budget app",
    "finance tracker app",
  ],
},

turnOnMpin: {
  title: "How to Turn On Secure PIN | Best Budget Security Guide",
  description:
    "Protect your financial information by enabling Secure PIN in Best Budget. Learn how to add an extra layer of security to your account.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "finance tracker app",
    "money management app",
    "security",
  ],
},

changeMpin: {
  title: "How to Change Secure PIN | Best Budget Help Guide",
  description:
    "Update your Secure PIN in Best Budget to keep your account protected. Follow our simple security guide and stay in control of your finances.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "finance tracker app",
    "security",
  ],
},

turnOffMpin: {
  title: "How to Turn Off Secure PIN | Best Budget Security Help",
  description:
    "Learn how to disable Secure PIN in Best Budget. Manage your account security settings quickly and confidently with our step-by-step guide.",
  primaryKeywords: ["personal finance app"],
  secondaryKeywords: [
    "money management app",
    "finance tracker app",
    "security",
  ],
},

getSupport: {
  title: "How to Get Support | Best Budget Help Center",
  description:
    "Need assistance? Learn how to contact Best Budget support, get answers to your questions and resolve issues quickly with our help resources.",
  primaryKeywords: ["best money management app"],
  secondaryKeywords: [
    "personal finance app",
    "money management app",
    "budget app",
  ],
},



};

export default seoConfig;
